import React, { useState, useEffect } from "react";
import { MessageBox } from "react-chat-elements";
import "./MessageStyles.css"; // Add this import

const Message = ({
  text,
  isUser,
  num_msgs,
  max_msgs,
  chat_name,
  img_logo,
  colors,
}) => {
  const [isEnglish, setIsEnglish] = useState(false);
  const [messageTime] = useState(new Date());

  useEffect(() => {
    const browserLang = navigator.language || navigator.languages[0];
    if (browserLang.startsWith("en")) {
      setIsEnglish(true);
    }
  }, []);

  const formatTime = (date) => {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  };

  const messageStyles = "!text-base [&_.rce-mbox-text]:!text-base font-sans";

  const userBubbleStyle = {
    backgroundColor: "#FFFFFF !important",
    borderRadius: "18px 0px 18px 18px !important",
    padding: "12px 16px 2px 16px !important",
    boxShadow: "none !important",
    border: "1px solid #000 !important",
    color: "inherit",
  };

  const assistantBubbleStyle = {
    backgroundColor: "#F0F0F0 !important",
    borderRadius: "0px 18px 18px 18px !important",
    padding: "12px 16px 2px 16px !important",
    boxShadow: "none !important",
    border: "1px solid #000 !important",
    color: "inherit",
  };

  const userContainerStyle = {
    margin: "8px 0",
  };

  const assistantContainerStyle = {
    margin: "8px 0",
  };

  const titleStyle = {
    color: colors || 'inherit',
    fontWeight: "bold",
    margin: "0.25rem",
  };

  return (
    <>
      {isUser ? (
        <MessageBox
          className={`items-end custom-user-message ${messageStyles} mt-4 mb-4`}
          position={"right"}
          type={"text"}
          title={<p style={titleStyle}>{isEnglish ? "You" : "Tú"}</p>}
          dateString={num_msgs + "/" + max_msgs}
          date
          avatar={"https://cdn-icons-png.flaticon.com/512/2102/2102647.png"}
          text={text}
          bubbleStyle={userBubbleStyle}
          containerStyle={userContainerStyle}
        />
      ) : (
        <MessageBox
          className={`custom-assistant-message ${messageStyles} w-5/6`}
          position={"left"}
          type={"text"}
          title={
            <p style={titleStyle}>
              {chat_name ? chat_name : isEnglish ? "Assistant" : "Asistente"}
            </p>
          }
          dateString={formatTime(messageTime)}
          date={messageTime}
          avatar={
            img_logo && img_logo !== ""
              ? img_logo
              : "https://cdn-icons-png.flaticon.com/512/2102/2102647.png"
          }
          text={text}
          bubbleStyle={assistantBubbleStyle}
          containerStyle={assistantContainerStyle}
        />
      )}
    </>
  );
};

export default Message;
